import React from "react";
import { Button, Card, Input } from "reactstrap";
import _ from "lodash-es";

const ForgotPasswordVerificationView = (props) => {
  const { handleEmailVerification, saveLoading, emailVerified, handleFieldChange } = props;
  return (
    <React.Fragment>
      <h4 style={{ marginBottom: "24px" }}>
        Are you having trouble logging in?
      </h4>
      <Card
        style={{
          padding: "20px",
          width: "100%",
          maxWidth: "600px",
          borderRadius: "6px",
        }}
      >
        <div style={{ fontWeight: "600" }}>
          {emailVerified ? (
            <React.Fragment>
              We have sent you a link to reset your
              password and get you back into your account. Remember to check
              your Spam folder!
            </React.Fragment>
          ) : (
            <React.Fragment>
              Enter your email address and we'll send you a link to reset your
              password and get you back into your account. Remember to check
              your Spam folder!
            </React.Fragment>
          )}
        </div>
        {!emailVerified && (
          <React.Fragment>
            <div className="mt-2">
              <label className="form-control-label" htmlFor="name">
                Email Address
              </label>
            </div>
            <div>
              <Input
                onChange={(e) =>
                  handleFieldChange({ value: e, field: "emailAddress" })
                }
                name="emailAddress"
                style={{ marginBottom: "24px" }}
              />
            </div>
            <Button
              color="success"
              onClick={handleEmailVerification}
              style={{
                width: "100%",
                fontWeight: "600",
                padding: "14px 0",
                cursor: "pointer",
              }}
              className={`${saveLoading ? 'no-pointer-events' : ""}`}
            >
              CONTINUE
            </Button>
          </React.Fragment>
        )}
      </Card>
    </React.Fragment>
  );
};

export default ForgotPasswordVerificationView;
